module.exports = __webpack_public_path__ + "img/ring_chart.7a61cf8d.svg";